module.exports = __webpack_public_path__ + "img/armhole back.89d0405f.png";